import { descriptionFieldRegex } from './const';

export const capitalizeFirstLetter = (string) => {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
};

export const validateInfiniteSearchField = (searchData) => {
  if (searchData.length <= 255 && descriptionFieldRegex.test(searchData)) {
    return true;
  }
  return false;
};

// helper for yup transform function
export function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
}

export const getRiskColor = (dataIndex) => {
  let variant;
  if (dataIndex !== undefined) {
    if (dataIndex === 'Nizak') {
      variant = 'success'
    } else if (dataIndex === 'Visok') {
      variant = 'warning'
    } else if(dataIndex === 'Veoma visok'){
      variant = 'danger'
    }else if (dataIndex === 'Veoma nizak') {
      variant = 'greenDark'
    }else if(dataIndex === 'Umjeren') {
      variant = 'orangeLight'
    }
  }
    return variant;
}


export const getRatingColor = (dataIndex) => {
  let color;
  if (dataIndex !== undefined) {
    dataIndex < 5 ? color = "green" : (dataIndex >= 5 && dataIndex < 10) ? color = "orange" : color = "red"
  }
  return color;
}